import * as Sentry from '@sentry/react';
import { env } from '@/env';
import getEnvironment from '@/lib/env-helpers';

if (env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: getEnvironment(),
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: getEnvironment() === 'production' ? 0.2 : 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    beforeSend(event) {
      return import.meta.env.MODE === 'development' ? null : event;
    },
  });
}
